var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9619 0.75C11.6809 0.75 12.3446 1.13599 12.7002 1.76095L15.6873 7.01095C16.0362 7.62416 16.0362 8.37584 15.6873 8.98905L12.7002 14.239C12.3446 14.864 11.6809 15.25 10.9619 15.25H5.03813C4.31909 15.25 3.65539 14.864 3.2998 14.239L0.312734 8.98905C-0.0361619 8.37584 -0.0361619 7.62416 0.312735 7.01095L3.2998 1.76095C3.65539 1.13599 4.31909 0.75 5.03813 0.75L10.9619 0.75Z",
    fill: "#E45C51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.995 4V8M7.995 12H8.005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.1bed6eb6ed3d3a66d7aa530bb5b70d62.svg";
export { ForwardRef as ReactComponent };